import { putRequest, getRequest } from '../config/auth';
import { FETCH_ONBOARDING, UPDATE_ONBOARDING, ONBOARDING_COUNT } from '../config/api-url';

export const getOnboardingAPI = (data) => getRequest(`${FETCH_ONBOARDING}`, data);
export const updateOnboardingAPI = (data) => putRequest(`${UPDATE_ONBOARDING}`, data);
export const getOnboardingCountAPI = (data) => getRequest(`${ONBOARDING_COUNT}`, data);
